import { MenuTreeNode, MenuTreeNodeProps } from "./MenuTreeNode";

export class MenuTreeNodeBranch extends MenuTreeNode {

    constructor(props: Partial<MenuTreeNodeProps>) {
        super({
            themeKey: "menu.branchNode",
            ...props
        });
        this.label.height = 32;
    }

    override set expanded(value: boolean) {
        if (this.expanded === value)
            return;
        super.expanded = value;
        if (this.isInitialized) {
            this.label.rotateWithTransition(this.expanded ? 0 : -90, 200);
        }
    }

    override get expanded(): boolean {
        return super.expanded;
    }
}
